import slugify from "slugify"

export function cn(...args) {
  return args.filter(Boolean).join(' ')
}

export function mapEdgesToNodes(data) {
  if (!data.edges) return []
  return data.edges.map(edge => edge.node)
}

export function buildImageObj(source) {
  const imageObj = {
    asset: {_ref: source.asset._ref || source.asset._id},
  }

  if (source.crop) imageObj.crop = source.crop
  if (source.hotspot) imageObj.hotspot = source.hotspot

  return imageObj
}


export function getPostDate(publishedAt, _updatedAt, withMessage = false) {
  const options = {year: 'numeric', month: 'short', day: 'numeric'}
  const publishedDate = new Date(publishedAt)
  const date = _updatedAt && daysPassed(publishedAt, _updatedAt) > 30
    ? `${new Date(_updatedAt).toLocaleDateString('fr-FR', options)}`
    : `${publishedDate.toLocaleDateString('fr-FR', options)}`

  return withMessage ? `Mis à jour le ${date}` : date
}

function daysPassed(publishedAt, _updatedAt) {
  const DAY = 1000 * 60 * 60 * 24
  return Math.round((new Date(_updatedAt).getTime() - new Date(publishedAt).getTime()) / DAY)
}

export function getTableColumns(headerRows, rows) {
  const columns = []

  headerRows && headerRows.map(headerRow => headerRow.cells.map((cell, index) => columns[index] = [cell]))
  rows && rows.map(row => row.cells.map((cell, index) => columns[index] ? columns[index].push(cell) : columns[index] = [cell]))

  return columns
}

export function getTableRows(headerRows, rows) {
  const tableRows = []
  headerRows && headerRows.map(headerRow => tableRows.push(headerRow))
  rows && rows.map(row => tableRows.push(row))
  return tableRows
}

export function getHeaderColumn(rows) {
  const cells = []
  rows.map(row => cells.push(row.cells[0]))
  return cells
}

export function blockToText(block) {
  return block.node.children.map(child => child.text).join('')
}

export function toPlainText(blocks = []) {
  return blocks && blocks
    .map(block => {
      if (block._type !== 'block' || !block.children) {
        return ''
      }
      return block.children.map(child => child.text).join('')
    })
    .join('\n\n') || ''
}


export function textToSlug(text) {
  return slugify(text,
    {
      lower: true,
      remove: /[*+~./,()'"!?:@0-9]/g,
    })
}

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}
